import { render, staticRenderFns } from "./detail-diaolg.vue?vue&type=template&id=a7b5ea0a&scoped=true"
import script from "./detail-diaolg.vue?vue&type=script&lang=js"
export * from "./detail-diaolg.vue?vue&type=script&lang=js"
import style0 from "./detail-diaolg.vue?vue&type=style&index=0&id=a7b5ea0a&prod&lang=less&scoped=true"
import style1 from "./detail-diaolg.vue?vue&type=style&index=1&id=a7b5ea0a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7b5ea0a",
  null
  
)

export default component.exports